import React, { useCallback } from "react";
import { Pressable, View, StyleSheet } from "react-native";
import color from "@constants/color";
import Text from "@components/CustomText";
import { useNavigation } from "@react-navigation/native";

const textPrimary = color.Gray20;
const textMuted = color.color_808080;

const SpokeChangeSubmitted: React.FC = () => {
  const navigation = useNavigation();

  const onDone = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  return (
    <>
      <View style={styles.container}>
        <View style={styles.iconWrapper}>
          <Text style={styles.iconEmoji}>✅</Text>
        </View>

        <Text variant="heading_24" style={styles.title}>
          Request Submitted!
        </Text>
        <Text variant="body_text_1" style={styles.subtitle}>
          Your spoke change request has been submitted. You will be notified once it is reviewed and approved.
        </Text>

        <Pressable
          style={styles.doneButton}
          onPress={onDone}
          accessibilityRole="button"
          accessibilityLabel="Done"
        >
          <Text variant="title_16" style={styles.doneButtonText}>
            Done
          </Text>
        </Pressable>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.white,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 32,
  },
  iconWrapper: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: color.veryLightGreen,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 28,
  },
  iconEmoji: { fontSize: 52 },
  title: { color: color.plain_green, textAlign: "center", marginBottom: 12 },
  subtitle: {
    color: textMuted,
    textAlign: "center",
    lineHeight: 22,
    marginBottom: 40,
  },
  doneButton: {
    backgroundColor: color.primary,
    borderRadius: 12,
    paddingVertical: 14,
    paddingHorizontal: 64,
    alignItems: "center",
  },
  doneButtonText: { color: color.white },
});

export default SpokeChangeSubmitted;
